<template>
  <div>
    <div class="">
      <b-tabs lazy fill Justified>
        <b-tab
          v-if="dataPermission.includes('CNPS_CSTM_NEED_BUSINESS_REG_LIST')"
          title="Danh sách MC cần bổ sung GP ĐKKD"
          :active="merchantActive"
        >
          <mc></mc>
        </b-tab>
        <b-tab
          v-if="dataPermission.includes('CNPS_WKCLDR_STICKER_IMAGE_GPDKKD')"
          title="Công việc Sale"
          :active="saleActive"
        >
          <sale></sale>
        </b-tab>
        <b-tab
          v-if="dataPermission.includes('CNPS_CALENDAR_WK_STANDEE_STICKER_IMAGE')"
          title="Công việc AFS"
          :active="afsActive"
        >
          <afs></afs>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
  import sale from './sale.vue'
  import afs from './afs.vue'
  import mc from './mc.vue'
  import { mapGetters } from 'vuex'
  export default {
    name: 'GPDKKD',
    data() {
      return {
        afsActive: this.$route.params.job === 'afs',
        saleActive: this.$route.params.job === 'sale',
        merchantActive: this.$route.params.job === 'mc',
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    components: { sale, afs, mc },
  }
</script>
